import React from 'react'

import DashActivityReport from 'components/Dashboard/SearchResultsCards/DashActivityReport'
import DashChallengeCard from 'components/Dashboard/SearchResultsCards/DashChallengeCard'
import DashCampaignCard from 'components/Dashboard/SearchResultsCards/DashCampaignCard'
import DashContributionCard from 'components/Dashboard/SearchResultsCards/DashContributionCard'
import DashLikeCard from 'components/Dashboard/SearchResultsCards/DashLikeCard'
import DashMembershipCard from 'components/Dashboard/SearchResultsCards/DashMembershipCard'
import DashNotificationCard from 'components/Dashboard/SearchResultsCards/DashNotificationCard'
import DashOppCard from 'components/Dashboard/SearchResultsCards/DashOppCard'
import DashboardOpportunityCard from 'components/OpportunityCard/DashboardOpportunityCard'
import DashOrganisationCard from 'components/Dashboard/SearchResultsCards/DashOrganisationCard'
import DashWorksiteCard from 'components/Dashboard/SearchResultsCards/DashWorksiteCard'
import DashWorkspaceCard from 'components/Dashboard/SearchResultsCards/DashWorkspace'
import DashWorkspaceProjectCard from 'components/Dashboard/SearchResultsCards/DashWorkspaceProjectCard'
import DashParticipantCard from 'components/Dashboard/SearchResultsCards/DashParticipantCard'
import DashPersonCard from 'components/Dashboard/SearchResultsCards/DashPersonCard'
import DashTrainingCard from 'components/Dashboard/SearchResultsCards/DashTrainingCard'
import DashTrainingSelectionCard from 'components/Dashboard/SearchResultsCards/DashTrainingSelectionCard'
import DashFormCard from 'components/Dashboard/SearchResultsCards/DashFormCard'
import DashPartnerCard from 'components/Dashboard/SearchResultsCards/DashPartnerCard'
import DashProgramCard from 'components/Dashboard/SearchResultsCards/DashProgramCard'
import DashStoryCard from 'components/Dashboard/SearchResultsCards/DashStoryCard'
import DashTeamCard from 'components/Dashboard/SearchResultsCards/DashTeamCard'
import PboApplicationCard from 'components/PboApplicationCard/PboApplicationCard'
import ShiftLogCard from 'components/ShiftLogCard/ShiftLogCard'
import OrganisationCard from 'components/OrganisationCard/OrganisationCard'
import PublicOpportunityCard from 'components/OpportunityCard/PublicOpportunityCard'

const RenderResultsCard = ({ card, cardType, hasGodAdminRole, userData }) => {
  const { key, ...cardProps } = card

  if (cardType === 'DashActivityReport') {
    return <DashActivityReport {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashChallengeCard') {
    return <DashChallengeCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashCampaignCard') {
    return <DashCampaignCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashContributionCard') {
    return <DashContributionCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashLikeCard') {
    return <DashLikeCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashMembershipCard') {
    return <DashMembershipCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashNotificationCard') {
    return <DashNotificationCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashOppCard') {
    return <DashOppCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashOrganisationCard') {
    return <DashOrganisationCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashParticipantCard') {
    return <DashParticipantCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashPersonCard') {
    return <DashPersonCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashTrainingCard') {
    return <DashTrainingCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashTrainingSelectionCard') {
    return <DashTrainingSelectionCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashWorksiteCard') {
    return <DashWorksiteCard {...cardProps} />
  }

  if (cardType === 'DashWorkspaceCard') {
    return <DashWorkspaceCard {...cardProps} />
  }

  if (cardType === 'DashWorkspaceProjectCard') {
    return <DashWorkspaceProjectCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashFormCard') {
    return <DashFormCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashPartnerCard') {
    return <DashPartnerCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashProgramCard') {
    return <DashProgramCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashStoryCard') {
    return <DashStoryCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'DashTeamCard') {
    return <DashTeamCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'PublicOpportunityCard') {
    return (
      <PublicOpportunityCard {...cardProps} hasGodAdminRole={hasGodAdminRole} userData={userData} />
    )
  }

  if (cardType === 'OrganisationCard') {
    return <OrganisationCard {...cardProps} hasGodAdminRole={hasGodAdminRole} userData={userData} />
  }

  if (cardType === 'DashboardOpportunityCard') {
    return <DashboardOpportunityCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'PboApplicationCard') {
    return <PboApplicationCard {...cardProps} hasGodAdminRole={hasGodAdminRole} />
  }

  if (cardType === 'ShiftLogCard') {
    return <ShiftLogCard {...cardProps} />
  }
}

export default RenderResultsCard
